module.exports = __webpack_public_path__ + "media/customizations/ontopoftheworld/logo-new-abc6a7470fe41da78bf04237a2a910af.png";